var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hfbeb3jqga",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.862745 0 0 0 0 0.000000 0 0 0 0 0.125490 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dxr1hfde8b",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.282353 0 0 0 0 0.517647 0 0 0 0 0.909804 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hfbeb3jqga)",
    transform: "translate(-503.000000, -286.000000) translate(464.000000, 188.000000) translate(32.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#dxr1hfde8b)",
    transform: "translate(7.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6539E9",
    fillRule: "nonzero",
    d: "M23.333 0C10.447 0 0 10.447 0 23.333c0 12.888 10.447 23.334 23.333 23.334 12.888 0 23.334-10.445 23.334-23.334C46.667 10.447 36.22 0 23.333 0zm0 42.292c-10.47 0-18.958-8.488-18.958-18.959 0-10.47 8.488-18.958 18.958-18.958 10.471 0 18.959 8.488 18.959 18.958 0 10.471-8.488 18.959-18.959 18.959zm.002-32.059c-1.671 0-2.936.872-2.936 2.28v12.922c0 1.41 1.264 2.28 2.936 2.28 1.63 0 2.935-.906 2.935-2.28V12.514c0-1.375-1.305-2.28-2.935-2.28zm0 20.392c-1.606 0-2.913 1.307-2.913 2.914 0 1.604 1.307 2.91 2.913 2.91 1.605 0 2.91-1.306 2.91-2.91 0-1.607-1.305-2.914-2.91-2.914z",
    transform: "translate(4.666667, 4.666667)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.91aa13b5.svg";
export { ForwardRef as ReactComponent };